export const RecentStars = () => {
  return (
    <div
    style={{
        width: "100%",
        height: "100%",
    }}
    >

    <svg width="56" height="65" viewBox="0 0 56 65" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.1475 31.7754C25.6298 33.7048 25.9373 35.0123 26.6299 36.0947C27.2147 37.0087 27.9913 37.7853 28.9053 38.3701C29.9877 39.0627 31.2952 39.3702 33.2246 39.8525L37.8145 41L33.2246 42.1475C31.2952 42.6298 29.9877 42.9373 28.9053 43.6299C27.9913 44.2147 27.2147 44.9913 26.6299 45.9053C26.1104 46.7171 25.8078 47.6554 25.4854 48.8877L25.1475 50.2246L24 54.8145L22.8525 50.2246L22.5146 48.8877C22.1922 47.6554 21.8896 46.7171 21.3701 45.9053L21.1416 45.5693C20.5887 44.8004 19.8945 44.1416 19.0947 43.6299L18.8887 43.5049C17.8461 42.8987 16.5842 42.5997 14.7754 42.1475L10.1846 41L14.7754 39.8525C16.5842 39.4003 17.8461 39.1013 18.8887 38.4951L19.0947 38.3701C19.8945 37.8583 20.5887 37.1996 21.1416 36.4307L21.3701 36.0947C21.8896 35.2829 22.1922 34.3446 22.5146 33.1123L22.8525 31.7754L24 27.1846L25.1475 31.7754Z" fill="url(#paint0_linear_62_576)" stroke="url(#paint1_linear_62_576)" stroke-width="3"/>
<path d="M40.7653 9.85034C41.0869 11.1367 41.2918 12.0086 41.7536 12.7302C42.1435 13.3394 42.661 13.857 43.2702 14.2468C43.9918 14.7085 44.863 14.9136 46.1491 15.2351L49.2097 15.9998L46.1491 16.7654C45.0239 17.0467 44.2162 17.2387 43.5485 17.5916L43.2702 17.7537C42.737 18.0949 42.2745 18.534 41.9059 19.0466L41.7536 19.2703C41.4072 19.8115 41.2049 20.4369 40.9899 21.2585L40.7653 22.1492L39.9997 25.2097L39.235 22.1492L39.0095 21.2585C38.7945 20.4371 38.5931 19.8115 38.2468 19.2703L38.0944 19.0466C37.7259 18.534 37.2633 18.0949 36.7302 17.7537L36.4518 17.5916C35.784 17.2385 34.9758 17.0468 33.8503 16.7654L30.7897 15.9998L33.8503 15.2351C34.976 14.9537 35.784 14.7611 36.4518 14.408L36.7302 14.2468C37.2633 13.9057 37.7259 13.4664 38.0944 12.9539L38.2468 12.7302C38.5931 12.189 38.7945 11.5633 39.0095 10.7419L39.235 9.85034L39.9997 6.78979L40.7653 9.85034Z" fill="url(#paint2_linear_62_576)" stroke="url(#paint3_linear_62_576)" stroke-width="2"/>
<defs>
<linearGradient id="paint0_linear_62_576" x1="24" y1="21" x2="24" y2="61" gradientUnits="userSpaceOnUse">
<stop stop-color="#191BDF"/>
<stop offset="1" stop-color="#FFCE03"/>
</linearGradient>
<linearGradient id="paint1_linear_62_576" x1="24" y1="21" x2="24" y2="61" gradientUnits="userSpaceOnUse">
<stop stop-color="#191BDF"/>
<stop offset="1" stop-color="#FFCE03"/>
</linearGradient>
<linearGradient id="paint2_linear_62_576" x1="40" y1="2.66675" x2="40" y2="29.3334" gradientUnits="userSpaceOnUse">
<stop stop-color="#191BDF"/>
<stop offset="1" stop-color="#FFCE03"/>
</linearGradient>
<linearGradient id="paint3_linear_62_576" x1="40" y1="2.66675" x2="40" y2="29.3334" gradientUnits="userSpaceOnUse">
<stop stop-color="#191BDF"/>
<stop offset="1" stop-color="#FFCE03"/>
</linearGradient>
</defs>
</svg>
</div>
  );
};

export default RecentStars;